customElements.get("product-form") ||
  customElements.define(
    "product-form",
    class extends HTMLElement {
      constructor() {
        super(),
          (this.form = this.querySelector("form")),
          (this.form.querySelector("[name=id]").disabled = !1),
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
          (this.cart =
            document.querySelector("cart-notification") ||
            document.querySelector("cart-drawer")),
          (this.submitButton = this.querySelector(
            '[id^="ProductSubmitButton-"]'
          )),
          (this.buyButton = this.querySelector('[id^="ProductBuyButton-"]')),
          this.buyButton &&
          (document.querySelector("cart-drawer") &&
            this.submitButton.setAttribute("aria-haspopup", "dialog"),
            (this.hideErrors = "true" === this.dataset.hideErrors));
      }

      async onSubmitHandler(t) {
        t.preventDefault();
        let cartItems = [];
        await fetch(routes.cart_url, fetchConfig())
          .then((t) => t.text())
          .then((t) => {
            cartItems = JSON.parse(t).items;
          });
        const e = !!t.submitter.id.startsWith("ProductBuyButton-");
        if (
          this.submitButton &&
          (t && "function" == typeof t.preventDefault && t.preventDefault(),
            "true" === this.submitButton.getAttribute("aria-disabled"))
        )
          return;
        const i = new FormData(this.form);
        this.handleErrorMessage(),
          this.submitButton &&
          (this.submitButton.setAttribute("aria-disabled", !0),
            e || this.submitButton.classList.add("loading")),
          this.buyButton &&
          (this.buyButton.setAttribute("aria-disabled", !0),
            e && this.buyButton.classList.add("loading"));
        const s = e
          ? this.buyButton
            ? this.buyButton.querySelector(".loading-overlay__spinner")
            : null
          : this.submitButton.querySelector(".loading-overlay__spinner");
        s && s.classList.remove("hidden");
        const r = fetchConfig("javascript");
        (r.headers["X-Requested-With"] = "XMLHttpRequest"),
          delete r.headers["Content-Type"];
        this.cart &&
          (i.append(
            "sections",
            this.cart.getSectionsToRender().map((t) => t.id)
          ),
            i.append("sections_url", window.location.pathname),
            this.cart.setActiveElement(document.activeElement));
        r.body = i;
        let n = false;
        e,
          fetch("" + routes.cart_add_url, r)
            .then((t) => t.json())
            .then(async (t) => {
              const s = [],
                r = { ...t };
              if (
                (s.length > 0 &&
                  ((t = await fetch(routes.cart_add_url + ".js", {
                    method: "POST",
                    body: JSON.stringify({
                      items: s,
                      sections: "cart-icon-bubble,cart-notification-button",
                    }),
                    headers: { "Content-Type": "application/json" },
                  }).then((t) => t.json())),
                    (r.sections["cart-icon-bubble"] =
                      t.sections["cart-icon-bubble"]),
                    (r.sections["cart-notification-button"] =
                      t.sections["cart-notification-button"])),
                  t.status)
              ) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: "product-form",
                  productVariantId: i.get("id"),
                  errors: t.errors || t.description,
                  message: t.message,
                }),
                  this.handleErrorMessage(t.description);
                const e = this.submitButton.querySelector(".sold-out-message");
                if (!e) return;
                return (
                  this.submitButton.setAttribute("aria-disabled", !0),
                  this.submitButton
                    .querySelector("span")
                    .classList.add("hidden"),
                  e.classList.remove("hidden"),
                  void (this.error = !0)
                );
              }
              if (!this.cart)
                return void (window.location = window.routes.cart_url);
              if (e)
                if (window.openRzpLogin) {
                  window.openRzpLogin(),
                    this.submitButton.classList.remove("loading"),
                    this.buyButton &&
                    this.buyButton.classList.remove("loading"),
                    this.cart &&
                    this.cart.classList.contains("is-empty") &&
                    this.cart.classList.remove("is-empty"),
                    this.submitButton.removeAttribute("aria-disabled"),
                    this.buyButton &&
                    this.buyButton.removeAttribute("aria-disabled");
                  const t =
                    this.buyButton &&
                    this.buyButton.querySelector(".loading-overlay__spinner");
                  t && t.classList.add("hidden");
                } else window.location = "/checkout";
              this.error ||
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: i.get("id"),
                  cartData: t,
                }),
                (this.error = !1);
              const d = this.closest("quick-add-modal");
              d
                ? (document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(t);
                    });
                  },
                  { once: !0 }
                ),
                  d.hide(!0))
                : e ||
                window.location.pathname === window.routes.cart_url ||
                this.cart.renderContents(r),
                (this.submitButton.innerHTML = "Added to Cart");
            })
            .catch((t) => {
              console.error(t);
            })
            .finally(async () => {
              e ||
                (this.submitButton.classList.remove("loading"),
                  this.buyButton && this.buyButton.classList.remove("loading")),
                this.cart &&
                this.cart.classList.contains("is-empty") &&
                this.cart.classList.remove("is-empty"),
                this.error ||
                e ||
                (this.submitButton.removeAttribute("aria-disabled"),
                  this.buyButton &&
                  this.buyButton.removeAttribute("aria-disabled")),
                !e && s && s.classList.add("hidden");
              if (t.submitter.classList.contains("wishlist-quick-add")) {
                document
                  .getElementById("cart-notification-overlay")
                  .classList.remove("active");
                const wishViewList =
                  document.getElementsByTagName("wish-view-list")[0];
                wishViewList.deleteWishItem(t.submitter.dataset.handle);
                document.getElementById("moved-to-cart").style.display = "flex";
                setTimeout(function () {
                  document.getElementById("moved-to-cart").style.display =
                    "none";
                }, 5000);
              }
            });
      }
      handleErrorMessage(t = !1) {
        this.hideErrors ||
          ((this.errorMessageWrapper =
            this.errorMessageWrapper ||
            this.querySelector(".product-form__error-message-wrapper")),
            this.errorMessageWrapper &&
            ((this.errorMessage =
              this.errorMessage ||
              this.errorMessageWrapper.querySelector(
                ".product-form__error-message"
              )),
              this.errorMessageWrapper.toggleAttribute("hidden", !t),
              t && (this.errorMessage.textContent = t)));
      }
    }
  );
